import { lazy } from 'react';

const ContactsPage = lazy(() => import('./pages/ContactsPage.jsx'));
const ContactDetailPage = lazy(() => import('./pages/ContactDetailPage.jsx'));

const moduleDef = {
  name: 'contact',
  routes: [
    { path: '/contacts', element: ContactsPage, permission: 'contact.view' },
    { path: '/contacts/:id', element: ContactDetailPage, permission: 'contact.view' },
  ],
  menu: [
    { path: '/contacts', label: 'Contacts', icon: 'ContactPage', order: 200, permission: 'contact.view' },
  ],
  providers: [],
};

export default moduleDef;
